// app/utils/idbUserRole.js
const DB_NAME = "suncore";
const STORE_NAME = "kv";
const DB_VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    if (!import.meta.client) return resolve(null);
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function setUserRoleInDb(role) {
  const db = await openDb();
  if (!db) return;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    store.put(role, "userRole");

    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getUserRoleFromDb() {
  const db = await openDb();
  if (!db) return null;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const req = store.get("userRole");

    req.onsuccess = () => resolve(req.result ?? null);
    req.onerror = () => reject(req.error);
  });
}

export async function clearUserRoleInDb() {
  const db = await openDb();
  if (!db) return;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    const req = store.delete("userRole");

    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

export async function isAdminFromDb() {
  const ruolo = await getUserRoleFromDb();
  return ruolo == 0;
}

export async function isUserFromDb() {
  const ruolo = await getUserRoleFromDb();
  return ruolo == 1;
}
